import { ROUTES } from "@app/constants";
import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { FC, Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/context/AuthContext";

interface Props {
  children: ReactNode;
}

export const ProtectedLayoutWrapper: FC<Props> = ({ children }) => {
  const { user, loading, logout } = useAuth();
  const { userDetails, isFetching } = useGetMe();

  if (loading || isFetching) {
    return <div>Loading...</div>;
  }

  if (userDetails?.userEntity?.type === "brand-user") {
    logout();
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return <Fragment>{children}</Fragment>;
};
